export default __webpack_public_path__ + "static/media/ReneeVettivelu.48090827.jpg";